module.exports = __webpack_public_path__ + "img/symbol_4.15507c1c.png";